import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefRankingType } from './interface/IRefRankingType';

@Entity('ref_ranking_type')
export class RefRankingType extends BaseEntity implements IRefRankingType{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;
}
